import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Textarea from '@adsk/alloy-react-textarea';
import { T } from '../../../helpers/i18n';
import { useRfiForm } from '../../RfiFormProvider';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../constants/issue-attribute-names';
import { CommonFormField } from '../../../components';

const FORM_FIELD_STYLE = { marginBottom: 10 };

const CommonTextarea = ({ fieldName, label }) => {
  const formik = useFormikContext();
  const { mandatoryFields, isSubmitting, refs } = useRfiForm();
  const isFieldsMandatory = mandatoryFields.includes(fieldName);
  const errorMessage = formik.touched[fieldName] && formik.errors[fieldName];

  /**
   * We use internal state and update formik when the internal state change.
   * We do that instead of using formik's state directly in order to prevent a bug:
   * the bug: while typing suggested answer event, the form is being scrolled with each keystroke
   */
  const [value, setValue] = useState(formik.values[fieldName]);
  useEffect(() => {
    formik.setFieldValue(fieldName, value);
  }, [value, fieldName]);

  return (
    <CommonFormField
      label={T.translate(label)}
      required={isFieldsMandatory}
      error={errorMessage}
      ref={refs[fieldName]}
      style={FORM_FIELD_STYLE}
    >
      <Textarea
        name={fieldName}
        style={{ width: '100%' }}
        onChange={(event) => setValue(event.target.value)}
        onBlur={formik.handleBlur}
        value={value}
        disabled={isSubmitting}
      />
    </CommonFormField>
  );
};

CommonTextarea.propTypes = {
  fieldName: PropTypes.oneOf(Object.values(ISSUE_ATTRIBUTE_NAMES)).isRequired,
  label: PropTypes.string.isRequired,
};

export default CommonTextarea;
